import React from 'react';
import { Crown, Star, TrendingUp, Zap, Award, Target, Sparkles, Eye } from 'lucide-react';
import '../../styles/website/PowerSection.css';

const PowerSection = () => {
  return (
    <section className="premium-section power-section" id="power">
      <div className="premium-container">
        <div className="premium-icon-wrapper premium-gold">
          <div className="premium-icon">
            <Crown size={64} />
          </div>
          <div className="icon-glow gold-glow"></div>
        </div>
        
        <div className="premium-content">
          <span className="premium-badge gold-badge">VIP Gold Section</span>
          <h2 className="premium-title gold-title">Power, Fame & Exceptional Dashboard</h2>
          <p className="premium-tagline">For those who want to rise higher — power, fame, success, destiny.</p>
          
          <p className="premium-description">
            A special section for people who want influence, fame, recognition, and higher purpose. Shows power cycles, breakthrough years, special talents, and your highest destiny.
          </p>
          
          <div className="premium-features">
            <div className="feature-item">
              <Star size={20} />
              <span>Public fame graph</span>
            </div>
            <div className="feature-item">
              <Crown size={20} />
              <span>Political power indicators</span>
            </div>
            <div className="feature-item">
              <TrendingUp size={20} />
              <span>Social rise windows</span>
            </div>
            <div className="feature-item">
              <Zap size={20} />
              <span>Major turning points</span>
            </div>
            <div className="feature-item">
              <Target size={20} />
              <span>Life purpose & highest soul aim</span>
            </div>
            <div className="feature-item">
              <Award size={20} />
              <span>Special destiny factors</span>
            </div>
            <div className="feature-item">
              <Eye size={20} />
              <span>Exclusive insights & hidden opportunities</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PowerSection;
